var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmallXbr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 38,
    viewBox: "0 0 50 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.1085 13.2101L13.3491 19.0329L18.7943 25.0115L26.3865 37.1252H37.3821L24.6587 18.8769L37.2773 1.25244H26.4387L19.1085 13.2101V13.2101Z",
    fill: "url(#paint0_linear_0_5527)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.3018 1.25244H1.30616L13.3491 19.0329L0.416016 37.1252H11.7783L18.7947 25.0115L24.6588 18.8769L19.109 13.2101L12.3018 1.25244V1.25244Z",
    fill: "url(#paint1_linear_0_5527)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.7515 1.48218H49.9242",
    stroke: "#3840CD",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M37.834 4.45239H49.9241",
    stroke: "#3840CD",
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1289 10.3928H49.9243",
    stroke: "#3840CD",
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5967 19.3044H49.9249",
    stroke: "#3840CD",
    strokeWidth: 2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9492 7.4231H49.9243",
    stroke: "#3840CD",
    strokeWidth: 2
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0015 16.3335H49.9242",
    stroke: "#3840CD",
    strokeWidth: 2
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9839 13.3635H49.9241",
    stroke: "#3840CD",
    strokeWidth: 2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_5527",
    x1: 36.8076,
    y1: 2.75244,
    x2: 14.7847,
    y2: 2.75244,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF81F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.186242,
    stopColor: "#9225FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.403841,
    stopColor: "#8318FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594083,
    stopColor: "#7426FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.813739,
    stopColor: "#3840CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#578EE1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_0_5527",
    x1: 24.0791,
    y1: 2.75275,
    x2: 1.86426,
    y2: 2.75275,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF81F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.236372,
    stopColor: "#9225FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.424716,
    stopColor: "#8318FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.621283,
    stopColor: "#7426FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.811682,
    stopColor: "#3840CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#578EE1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallXbr);
export default __webpack_public_path__ + "static/media/small_xbr.0178cac9e9bd6fc46d0c72ed6ae14c5b.svg";
export { ForwardRef as ReactComponent };